module.exports = __webpack_public_path__ + "img/logo-sml-white.7eea5f02.png";